<template>
    <div>
        <v-container v-if="tenantHasFeature('Applications')" fluid class="my-0 px-0  py-0">
            <q-content-submenu ref="contentMenu" v-if="!hasRole('SuperAdmin')"></q-content-submenu>
            <v-row wrap class="mx-7" :style="!hasRole('SuperAdmin') ? 'padding-top:100px;' : ''">
                <v-col cols="12">
                    <h2>Submitted Applications 
                        <v-btn v-if="!hasRole('SuperAdmin')" large color="primary" @click="showAppForm = true">
                            Submit New Application Record
                            <v-icon right>fas fa-plus</v-icon>
                        </v-btn>
                    </h2>
                    <q-applications-bulk-edit-data-table v-if="hasPermission('manage:Applications')"  :agentCode="null" :rows="25" title="Review Submitted Applications"></q-applications-bulk-edit-data-table>
                    <q-applications-data-table v-else :agentCode="null" :rows="25" title="Submitted Applications"></q-applications-data-table>
                </v-col>
            </v-row>
            <v-dialog width="70%" persistent v-model="showAppForm">
                <v-card class="pa-10">
                    <q-new-application  ref="appform" v-on:close="closeApp"></q-new-application>
                </v-card>
            </v-dialog>
        </v-container>
        <v-container v-else fluid class="my-0 px-0  py-0">
            You HQ instance does not have applications enabled. Please contact support to enable. 
        </v-container>
    </div>
</template>
<script>
//table data + search
import QApplicationsBulkEditDataTable from '@/components/datatables/QApplicationsBulkEditDataTable.vue';
import QApplicationsDataTable from '@/components/datatables/QApplicationsDataTable.vue';
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue'
import QNewApplication from '@/components/applications/QNewApplication.vue'
export default {
    data() {
        return {
            showAppForm : false
        }
    },
    methods: {
        closeApp : function(){
            this.showAppForm = false;
        }
    },
    watch : {
        'showAppForm' : function(){
            this.$nextTick(() => this.$refs.appform.reset());
        }
    },
    components: {
        QContentSubmenu,
        QApplicationsDataTable,
        QNewApplication,
        QApplicationsBulkEditDataTable
    }
}
</script>